import styled from 'styled-components';
import Box from '../../base/Box';

export const Container = styled(Box).attrs(({ isOverlapped }) => ({
  position: 'relative',
  flex: '0 0 auto',
  marginLeft: isOverlapped ? '5px' : 0,
}))``;

export const Avatar = styled(Box).attrs(({ displayActiveIndicator }) => ({
  position: 'relative',
  width: displayActiveIndicator ? '16px' : '24px',
  height: displayActiveIndicator ? '16px' : '24px',
  inline: true,
  align: 'center',
  justify: 'center',
  backgroundColor: 'lightLineDivider',
}))`
  border: ${({ theme }) => `1px solid ${theme.colors.background}`};
  border-radius: 50%;
  font-family: 'Roboto-Regular', sans-serif;
  font-size: 10px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.primaryText};
  text-transform: uppercase;
  z-index: 10;
  cursor: default;
`;

export const ActiveIndicator = styled.div`
  width: 8px;
  height: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.background}`};
  border-radius: 50%;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.success : theme.colors.heavyLineOutline};
  z-index: 15;
`;
